import { z } from 'zod'

export const batchDeleteExpensesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(500),
})

export type BatchDeleteExpensesDto = z.infer<typeof batchDeleteExpensesSchema>
